import { render, staticRenderFns } from "./PeriodsDisplay.vue?vue&type=template&id=78a6d6fc&scoped=true&"
import script from "./PeriodsDisplay.vue?vue&type=script&lang=js&"
export * from "./PeriodsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./PeriodsDisplay.vue?vue&type=style&index=0&id=78a6d6fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a6d6fc",
  null
  
)

export default component.exports